const checkboxes          = document.querySelectorAll('.freqbuy_select_item');
const frequantlyBuyATCBtn = document.getElementById('frequantly_buy_atc_btn');
const freqbuyPrice        = document.querySelector('.freqbuy-total-price');
const freqbuyPlusIcon     = document.querySelector('.freqbuy_images .plus-sign');
const freqbuyVariants     = document.querySelectorAll('.freqbuy_items .freqbuy-variant-select');


freqbuyVariants.forEach(freqbuyVariant => {
  console.log('freqbuyVariant', freqbuyVariant);

  freqbuyVariant.addEventListener('change', function () {
    const option = this.options[this.selectedIndex];
    const price = option.dataset.price;
    const variantId = option.value;

    const thisVarCheckbox = this.closest('.freqbuy_select_item').querySelector('.freqbuy-item');
    thisVarCheckbox.dataset.price = price;
    thisVarCheckbox.dataset.variantid = variantId;

    const thisItemPrice = this.closest('.freqbuy_select_item').querySelector('.product_price');
    thisItemPrice.textContent = localizeCurrency(price);
  });
});



function toggleItem(container) {
  // const checkbox = container.querySelector('.freqbuy-item');
  updateFreqATCBtnState();

  // update total
  updateFreqBuyTotal();
}

function updateFreqBuyTotal() {
  const allCheckboxes = document.querySelectorAll('.freqbuy_items .freqbuy-item:checked');
  const mainPrice = document.querySelector('.freqbuy_total .main-price');
  const saveOnBuyTogether = document.querySelector('.freqbuy_atc .save_on_buy_together');
  let saveBuyTogether = null;
  if (saveOnBuyTogether) {
    saveBuyTogether = saveOnBuyTogether.dataset.buyTogether * 100;
  }
  
  if (allCheckboxes.length >= 2) {
    freqbuyPlusIcon?.classList.remove('hidden');
    if (mainPrice) {
      mainPrice.classList.remove('hidden');
    }
  } else {
    freqbuyPlusIcon?.classList.add('hidden');
    if (mainPrice) {
      mainPrice.classList.add('hidden');
    }
  }

  let total = 0;
  let checkedCount = 0;
  allCheckboxes.forEach(cb => {
    total += parseFloat(cb.dataset.price) || 0;
    if (cb.checked) {
      checkedCount++;
    }
  });

  console.log('saveBuyTogether ', saveBuyTogether)
  console.log('checkedCount ', checkedCount)
  console.log('total ', total)

  if (checkedCount >= 2) {
    total -= saveBuyTogether
  }
  freqbuyPrice.textContent = localizeCurrency(total);
}

function localizeCurrency(amount) {
  const locale        = window.Shopify.locale;
  const country       = window.Shopify.country;
  const currencyCode  = window.Shopify.currency.active;

  return new Intl.NumberFormat(`${locale}-${country}`, {
    style: 'currency',
    currency: currencyCode,
  }).format(amount / 100);
}


function updateFreqATCBtnState() {
  const container = document.querySelector('.frequently_bought_container');
  const anyChecked = [...container.querySelectorAll('.freqbuy-item')].some(cb => cb.checked);
  frequantlyBuyATCBtn.disabled = !anyChecked;

  const allCheckboxes = container.querySelectorAll('.freqbuy-item');
  allCheckboxes.forEach(checkbox => {
    const productId = checkbox.dataset.productid;
    if (checkbox.checked) {
      const hideUnselected  = container.querySelector(`.product_${productId}`);
      hideUnselected.classList.remove('hidden');
    } else {
      const hideUnselected  = container.querySelector(`.product_${productId}`);
      hideUnselected.classList.add('hidden');
    }
  });

}

if (!customElements.get('frequantly-buy-form')) {
  customElements.define('frequantly-buy-form', class FrequantlyBuyForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      // frequantily bought items adding into cart using APi for multiple items
      await this.frequantlyBuyAddToCart();

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    async frequantlyBuyAddToCart() {
      const selectedItems = [];
      const checkboxes = document.querySelectorAll('.freqbuy-item');

      checkboxes.forEach(checkbox => {
        if (checkbox.checked) {
          const variantId = checkbox.dataset.variantid;
          selectedItems.push({
            id: parseInt(variantId),
            quantity: 1
          });
        }
      });

      console.log("selectedItems", selectedItems);

      // Update form with the first item
      if (selectedItems.length >= 1) {
        const form = document.querySelector('frequantly-buy-form form');
        if (form) {
          const idInput = form.querySelector('input[name="id"]');
          const qtyInput = form.querySelector('input[name="quantity"]');
          if (idInput && qtyInput) {
            idInput.value = selectedItems[0].id;
            qtyInput.value = selectedItems[0].quantity;
          }
        }
      }

      if (selectedItems.length === 0 || selectedItems.length === 1) {
        return;
      }

      // Remove the first item already added to form
      selectedItems.shift();
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: selectedItems })
      });
      const data = await response.json();
      console.log("Additional items response:", data);
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
